import { Popover, useDisclosure } from '@chakra-ui/react';
import { IUsageTypeResSchema } from '@monetize/types/app';
import FocusLock from 'react-focus-lock';
import { MGrid, MGridItem, MLink, MText } from '../../../components/Monetize';
import { FOCUS_WITHOUT_SCROLLING } from '../../../components/Monetize/Overlays';
import { USAGE_TYPE_STATUS_DISPLAY } from '../../../constants/usageTypes';

interface UsageTypeDetailsProps {
  usageType: IUsageTypeResSchema;
}

export const UsageTypeDetails = ({ usageType }: UsageTypeDetailsProps) => {
  const { onOpen, onClose, open: isOpen } = useDisclosure();

  const { pluralName, status, description, unitName, decimalPlaces } =
    usageType;

  return (
    <Popover.Root
      lazyMount
      unmountOnExit
      open={isOpen}
      onOpenChange={(e) => {
        if (e.open) {
          onOpen();
        } else {
          onClose();
        }
      }}
      positioning={{
        placement: 'right',
      }}
    >
      <Popover.Trigger asChild>
        <MLink onClick={onOpen} fontSize="sm" cursor="pointer">
          {usageType.name}
        </MLink>
      </Popover.Trigger>
      <Popover.Positioner>
        <Popover.Content p={4} border="0" boxShadow="popover">
          <FocusLock
            focusOptions={FOCUS_WITHOUT_SCROLLING}
            persistentFocus={false}
          >
            <Popover.Arrow mt="1" />

            <MGrid templateColumns="repeat(12, 1fr)" gap={2}>
              <MGridItem colSpan={12}>
                <MText fontWeight="bold" mb="1">
                  Description
                </MText>
                <MText>{description}</MText>
              </MGridItem>

              <MGridItem colSpan={4}>
                <MText fontWeight="bold" mb="1">
                  Unit Name
                </MText>
                <MText>{unitName}</MText>
              </MGridItem>

              <MGridItem colSpan={4}>
                <MText fontWeight="bold" mb="1">
                  Plural Name
                </MText>
                <MText>{pluralName}</MText>
              </MGridItem>

              <MGridItem colSpan={4}>
                <MText fontWeight="bold" mb="1">
                  Status
                </MText>
                <MText>{USAGE_TYPE_STATUS_DISPLAY[status]}</MText>
              </MGridItem>

              <MGridItem colSpan={4}>
                <MText fontWeight="bold" mb="1">
                  Decimal Place
                </MText>
                <MText>{decimalPlaces}</MText>
              </MGridItem>
            </MGrid>
          </FocusLock>
        </Popover.Content>
      </Popover.Positioner>
    </Popover.Root>
  );
};
